import styled from 'styled-components';
import { colors } from '../../../utils/constants';

export const Container = styled.div`
  width: 100%;
  background: white;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 2px ${colors.grey};
`;
